<p-toast></p-toast>
<div class="card relative">

  <kc-data-table
    [value]="data"
    [columns]="columns"
    (selectionChange)="onSelectionChanged($event)"
    [enableSelection]="false"
    [enableSearch]="enableSearch"
    [enableFilterReset]="enableFilterReset"
    [topbarTemplate]="topbarTemplate"
    [totalRecords]="totalRecords"
    [rows]="rows"
    (onLazyLoad)="onLazyLoad.emit($event)"
  >
    <ng-template #customCaption>
      <p-button icon="pi pi-plus" class="me-2" [rounded]="true" severity="success" [outlined]="true"
                (click)="onCreate.emit()" pTooltip="Nuovo" [disabled]="!canCreate"/>
    </ng-template>
  </kc-data-table>

  <kc-loader [loading]="loading" />
</div>
